'use client';

import { useTranslation } from '@weareconceptstudio/core';
import { getHomeCategories } from '@/libs/get-data';

//* Components
import CashBack from '@/modules/_Sections/CashBack';
import Categories from '@/modules/_Sections/Categories';
import SliderInstagram from '@/modules/_Sections/SliderInstagram';
import Review from '@/modules/_Sections/Review';
import ContentAbout from '../ContentAbout';
import HeroAbout from '../HeroAbout';
import LazySection from '@/components/LazySection';
import SkeletonSliderReview from '@/modules/_Sections/Review/Skeleton';
import LazyLoadWithData from '@/components/LazyLoadWithData';
import CategoriesSkeleton from '@/modules/_Sections/Categories/Skeleton';

//* Style
import AboutUsTemplateStyle from './style';

const AboutUsTemplate = ({ pageData }) => {
	const { selectedLang } = useTranslation();

	return (
		<AboutUsTemplateStyle>
			<HeroAbout
				mobileImage={pageData.image_mobile}
				desktopImage={pageData.image_main}
				description={pageData.description}
				title={pageData.title}
			/>

			<ContentAbout
				mission={pageData.mission}
				vision={pageData.vision}
				image={pageData.images}
			/>

			<LazyLoadWithData
				fetchKey={['home-categories', selectedLang]}
				fetcher={(_, selectedLang) => getHomeCategories({ lang: selectedLang })}
				fallback={<CategoriesSkeleton />}>
				{(categories) => <Categories categories={categories} />}
			</LazyLoadWithData>

			<CashBack />

			<LazySection
				delay={500}
				fallback={<SkeletonSliderReview />}>
				<Review />
			</LazySection>

			<SliderInstagram />
		</AboutUsTemplateStyle>
	);
};

export default AboutUsTemplate;
